import React from "react";
import { TabPane } from "reactstrap";
import { TechnicalDesignInputModes } from "stores/product/ui/projectUIStore";
import { TechnicalInputs } from "./components/TechnicalInputs";
import styles from "../ProductConfigurationResultMainView.module.scss";
import { TechnicalResults } from "./components/TechnicalResults";
import { AcousticResults } from "./components/AcousticResults";

export const SingleSelectionTab = () => {
  return (
    <TabPane tabId={TechnicalDesignInputModes.SINGLE_SELECTION}>
      <div className={styles.mainGrid}>
        <TechnicalInputs />
        <TechnicalResults />
        <AcousticResults />
      </div>
    </TabPane>
  );
};
